<template>
  <va-create-layout>
    <robot-department-form :title="title" :item="item"></robot-department-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"]
};
</script>
